import { render, staticRenderFns } from "./ComEmail.vue?vue&type=template&id=a9aa461e&scoped=true&"
import script from "./ComEmail.vue?vue&type=script&lang=js&"
export * from "./ComEmail.vue?vue&type=script&lang=js&"
import style0 from "./ComEmail.vue?vue&type=style&index=0&id=a9aa461e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9aa461e",
  null
  
)

export default component.exports